import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * book endpoints
 */
export const fetchBooks = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/books', q, page, perPage, sortOpts, extraParams);

export const fetchBook = (bookId) => request.fetchDetail(`/books/${bookId}`);

export const createBook = (payload) =>
  request.postJSON(
    '/books',
    excludeObjNullValue({
      title: payload.title,
      isbn: payload.isbn,
      publisher: payload.publisher,
      year_published: parseInt(payload.yearPublished),
      author: payload.author,
      illustrator: payload.illustrator,
    }),
  );

export const updateBook = (payload) =>
  request.putJSON(
    `/books/${payload.bookId}`,
    excludeObjNullValue({
      title: payload.title,
      isbn: payload.isbn,
      publisher: payload.publisher,
      year_published: parseInt(payload.yearPublished),
      author: payload.author,
      illustrator: payload.illustrator,
    }),
  );

export const deleteBook = (bookId) => request.deleteReq(`/books/${bookId}`);

export const toggleBookStatus = (bookId) => request.putJSON(`/books/${bookId}/status`, {});
